import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, OccInitCardBindingResponse, OccPaymentsResponse, Payment } from '@payment/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PAYMENTS_NORMALIZER } from '../converters/occ-payments-normalizer';

@Injectable({
  providedIn: 'root',
})
export class OccPaymentService {
  constructor(
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient,
    private converter: ConverterService,
  ) {}

  getPayments(): Observable<Payment[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.paymentDetailsAll, {
      queryParams: { fields: 'FULL' },
    });

    return this.http
      .get<OccPaymentsResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.paymentDetailsAll),
      })
      .pipe(this.converter.pipeable(PAYMENTS_NORMALIZER));
  }

  deletePayment(bindingId: string): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.paymentDetails, { urlParams: { bindingId } });

    return this.http
      .delete<unknown>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.paymentDetails),
      })
      .pipe(map(() => undefined));
  }

  bindPayment(cartId: string, bindingId?: string): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.paymentDetailsBinding, {
      urlParams: { cartId },
      queryParams: { bindingId, paymentLater: false },
    });

    return this.http
      .put<unknown>(url, null, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.paymentDetailsBinding),
      })
      .pipe(map(() => undefined));
  }

  unbindPayment(cartId: string): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.paymentDetailsBinding, {
      urlParams: { cartId },
    });

    return this.http
      .delete<unknown>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.paymentDetailsBinding),
      })
      .pipe(map(() => undefined));
  }

  initCardBindingOnExternalAddress(returnUrl: string): Observable<OccInitCardBindingResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.initCardBinding);

    return this.http.post<OccInitCardBindingResponse>(
      url,
      { returnUrl },
      {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.initCardBinding),
      },
    );
  }
}
